export default __webpack_public_path__ + "static/media/building-6.b143203a.png";